import { LuCircleAlert } from "react-icons/lu";

export const Error = (props: { error?: string }) => {
  const { error = "Something went wrong. Please try again." } = props;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      <LuCircleAlert
        style={{
          fontSize: "24px",
          color: "red",
        }}
      ></LuCircleAlert>
      <span style={{ fontSize: "16px", color: "red" }}>{error}</span>
    </div>
  );
};
